import { capitalize } from "lodash";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const ConversationStatusPill = ({
  status,
}: {
  status: "draft" | "closed" | "solved" | "open";
}) => {
  if (status === "draft") {
    return (
      <div className="flex h-6 items-center justify-center gap-2 rounded-[32px] px-2 py-[3px]">
        <Typography.LabelSm color="text-tertiary" weight="medium">
          {capitalize(status)}
        </Typography.LabelSm>
      </div>
    );
  }

  const textColor = {
    closed: "text-tertiary",
    solved: "text-date-blue",
    open: "text-white",
  }[status];

  return (
    <div
      className={classNames(
        "flex h-6 items-center justify-center gap-2 rounded-[32px] px-2 py-[3px]",
        {
          "bg-secondary": status === "closed" || status === "solved",
          "bg-[#16A34A]": status === "open",
        },
      )}
    >
      <Typography.LabelXs color={textColor} weight="medium">
        {capitalize(status)}
      </Typography.LabelXs>
    </div>
  );
};
